import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

import styles from './Backdrop.scss';

const transitionClassNames = {
    enter: styles.enter,
    enterActive: styles.enterActive,
    exit: styles.exit,
    exitActive: styles.exitActive,
};

Backdrop.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
};

Backdrop.defaultProps = {
    isOpen: false,
};

export default function Backdrop({ isOpen, onClose }) {
    return (
        <CSSTransition classNames={transitionClassNames} in={isOpen} unmountOnExit timeout={600}>
            <div className={styles.root} onClick={onClose} />
        </CSSTransition>
    );
}
